import React from 'react'

const Penwrite = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M19.1905 8.04767L20.4286 9.28577M21.0476 4.95243C21.2917 5.19621 21.4853 5.4857 21.6174 5.80437C21.7495 6.12303 21.8175 6.46461 21.8175 6.80957C21.8175 7.15454 21.7495 7.49612 21.6174 7.81478C21.4853 8.13345 21.2917 8.42294 21.0476 8.66672L9.28569 20.4286L4.33331 21.6667L5.57141 16.7837L17.3383 4.95738C17.8021 4.49133 18.4241 4.21671 19.081 4.18804C19.7379 4.15937 20.3815 4.37875 20.8842 4.80262L21.0476 4.95243Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8"></path>
<path d="M12 22L15 20.5L18.5 22L22 20.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeOpacity="0.5" strokeWidth="1.2381"></path>
</svg>
    )
}

export default Penwrite
